export type TimelineEvent = {
  time: string;
  title: string;
  icon?: string;
  sourceStatus?: "confirmed" | "needsConfirmation";
  sourceNote?: string;
};

export const timeline: TimelineEvent[] = [
  {
    time: "13:45",
    title: "Érkezés a templomhoz"
  },
  {
    time: "14:00",
    title: "Egyházi szertartás"
  },
  {
    time: "15:05",
    title: "Az egyházi szertartás vége – sorfal"
  },
  {
    time: "15:15",
    title: "Csoportkép és indulás a Nairamba"
  },
  {
    time: "15:45",
    title: "Érkezés a Nairamba"
  },
  {
    time: "16:15",
    title: "Vendégvárás a Nairamban – Vízpart"
  },
  {
    time: "17:15",
    title: "Polgári szertartás"
  },
  {
    time: "18:00",
    title: "Közös fotózás"
  },
  {
    time: "19:00",
    title: "Vacsora"
  },
  {
    time: "21:00",
    title: "Nyitótánc"
  },
  {
    time: "22:50",
    title: "Menyasszonyi torta"
  },
  {
    time: "23:50",
    title: "Menyasszonytánc"
  },
  {
    time: "00:30",
    title: "Éjszakai vacsora"
  },
  {
    time: "04:00-ig",
    title: "Tánc"
  }
];

export const arrivalGuide: TimelineEvent[] = timeline.slice(0, 3);

export type Highlight = {
  title: string;
  description: string;
  photo: string;
  sourceStatus: "confirmed" | "needsConfirmation";
  sourceNote: string;
};

export const highlights: Highlight[] = [
  {
    title: "Közös utak",
    description:
      "Szeretünk úton lenni, új helyeket felfedezni, és közben olyan emlékeket gyűjteni, amelyekből később közös történetek lesznek.",
    photo: "/images/photo1.jpg",
    sourceStatus: "confirmed",
    sourceNote: "Vendégeknek szánt, általános képaláírás."
  },
  {
    title: "Ketten a világban",
    description:
      "A hétköznapok és az utazások mellett is az a legfontosabb, hogy együtt tudjuk megélni a nagy és a csendes pillanatokat is.",
    photo: "/images/photo2.jpg",
    sourceStatus: "confirmed",
    sourceNote: "Vendégeknek szánt, általános képaláírás."
  },
  {
    title: "Hétköznapi pillanatok",
    description:
      "Az esküvő számunkra ezeknek a közös pillanatoknak a folytatása: egy nap, amikor a hozzánk közel állókkal ünnepelhetünk.",
    photo: "/images/photo3.jpg",
    sourceStatus: "confirmed",
    sourceNote: "Vendégeknek szánt, általános képaláírás."
  }
];

export const venue = {
  ceremony: {
    name: "Szolnoki Belvárosi Szentháromság-templom",
    address: "5000 Szolnok, Templom út 8.",
    mapsUrl:
      "https://www.google.com/maps/dir/?api=1&destination=Szolnoki+Belv%C3%A1rosi+Szenth%C3%A1roms%C3%A1g-templom%2C+5000+Szolnok,+Templom+%C3%BAt+8.",
    mapsEmbedUrl:
      "https://www.google.com/maps?q=Szolnoki%20Belv%C3%A1rosi%20Szenth%C3%A1roms%C3%A1g%20templom%2C%20Szolnok%2C%20Templom%20%C3%BAt%208&output=embed",
    parking:
      "Elsősorban a Sütő utcában vagy a Mészáros Lőrinc utcában parkoljatok. Ha ott nincs hely, a Tisza parknál vagy a Vízügyi székháznál érdemes megállni. Szombaton 14:00-kor a parkolás díjmentes.",
    parkingInfoUrl:
      "https://nhszszolnok.hu/szolnok/parkolasrol-altalanosan/",
    parkingMapEmbedUrl:
      "https://www.openstreetmap.org/export/embed.html?bbox=20.1875%2C47.1695%2C20.2025%2C47.1782&layer=mapnik",
    parkingOptions: [
      {
        number: "1",
        name: "Sütő utca és Sütő köz",
        walk: "1–3 perc",
        position: { left: "34%", top: "46%" },
        mapsUrl:
          "https://www.google.com/maps/dir/?api=1&destination=S%C3%BCt%C5%91+utca%2C+Szolnok"
      },
      {
        number: "2",
        name: "Mészáros Lőrinc utca",
        walk: "2–4 perc",
        position: { left: "28%", top: "39%" },
        mapsUrl:
          "https://www.google.com/maps/dir/?api=1&destination=M%C3%A9sz%C3%A1ros+L%C5%91rinc+utca+24%2C+Szolnok"
      },
      {
        number: "3",
        name: "Tisza park",
        walk: "kb. 5 perc",
        position: { left: "54%", top: "76%" },
        mapsUrl:
          "https://www.google.com/maps/dir/?api=1&destination=Tisza+park%2C+Szolnok"
      },
      {
        number: "4",
        name: "Vízügyi székház",
        walk: "kb. 7–10 perc",
        position: { left: "45%", top: "17%" },
        mapsUrl:
          "https://www.google.com/maps/dir/?api=1&destination=Boldog+S%C3%A1ndor+Istv%C3%A1n+k%C3%B6r%C3%BAt+4%2C+Szolnok"
      }
    ],
    churchPosition: { left: "19%", top: "77%" }
  },
  reception: {
    name: "Nairam Rendezvényközpont",
    address: "5081 Szajol, Külterület Hrsz. 096/8",
    mapsUrl:
      "https://www.google.com/maps/dir/?api=1&destination=Nairam+Rendezv%C3%A9nyk%C3%B6zpont%2C+5081+Szajol%2C+K%C3%BClter%C3%BClet+096%2F8",
    mapsEmbedUrl:
      "https://www.google.com/maps?q=Szajol+Nairam+rendezv%C3%A9nyk%C3%B6zpont+5081&output=embed",
    parking:
      "A Nairam különálló, zárt parkolója a vendégek számára díjmentesen használható."
  },
  transferMapsUrl:
    "https://www.google.com/maps/dir/?api=1&origin=Szolnoki+Belv%C3%A1rosi+Szenth%C3%A1roms%C3%A1g-templom%2C+5000+Szolnok%2C+Templom+%C3%BAt+8.&destination=Nairam+Rendezv%C3%A9nyk%C3%B6zpont%2C+5081+Szajol%2C+K%C3%BClter%C3%BClet+096%2F8&travelmode=driving",
  mapEmbedUrl:
    "https://www.google.com/maps?q=Szajol+Nairam+rendezv%C3%A9nyk%C3%B6zpont&output=embed"
};

export const eventDetails = {
  date: "2026. augusztus 29.",
  day: "Szombat",
  time: "14:00-tól",
  region: "Szolnok · Szajol",
  rsvpPath: "/rsvp/"
};

export type DietaryPreferenceOption = {
  value: string;
  label: string;
  description: string;
};

export const dietaryPreferenceOptions: DietaryPreferenceOption[] = [
  {
    value: "omnivore",
    label: "Normál menü",
    description: "Nincs külön étkezési kérés."
  },
  {
    value: "vegetarian",
    label: "Vegetáriánus",
    description: "Húsmentes étkezést kér."
  },
  {
    value: "other",
    label: "Egyéb étkezési igény",
    description: "Kérjük, írjátok le a megjegyzésnél, hogy egyeztetni tudjuk."
  }
];

export const rsvpResearchTopics = [
  "egy kapcsolattartó alatt több vendég is megadható legyen",
  "minden vendég külön névvel, életkorral és részvételi szándékkal szerepeljen",
  "az ottalvás vendégenként külön jelezhető legyen",
  "az allergiák és étkezési igények könnyen megadhatók legyenek",
  "több zenei kérés vagy YouTube-link is küldhető legyen"
];

export type AllergenOption = {
  value: string;
  label: string;
};

export const commonAllergens: AllergenOption[] = [
  { value: "gluten", label: "Glutén" },
  { value: "lactose", label: "Laktóz" },
  { value: "milk-protein", label: "Tejfehérje" },
  { value: "egg", label: "Tojás" },
  { value: "nuts", label: "Diófélék" },
  { value: "soy", label: "Szója" }
];

export const accommodationInfo = {
  title: "Szállás az este után",
  description:
    "Aki előre szállást kért, a Nairam Rendezvényközpontban kap szobát. A szállás és a reggeli díja a helyszínen rendezhető.",
  price: "11 200 Ft / fő / éj",
  breakfastPrice: "4 400 Ft / fő",
  stayWindow:
    "A szobák 14:00-tól vehetők át; a nap menete miatt ezt a Nairamba érkezés után érdemes intézni. Kijelentkezés másnap 11:00-ig.",
  paymentNote:
    "A szállás és a reggeli díja a recepción, a szobakulcs átvételekor rendezhető készpénzzel, bankkártyával vagy SZÉP-kártyával.",
  sourceStatus: "confirmed",
  warning: ""
};
